import {
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Popover,
  Row,
  TimePicker,
  Tooltip,
} from "antd";
import axios from "axios";
import moment from "moment";
import React from "react";
import "./OnboardingLocationCard.less";

export const OnboardingLocationCard = ({ id, form }) => {
  const handleZipcodeChange = async (e, id) => {
    if (
      !form.getFieldValue("zipcode" + id) ||
      form.getFieldError("zipcode" + id).length !== 0
    ) {
      return false;
    }
    const zipcode = e.target.value;
    let data = await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${zipcode.replace(
        " ",
        ""
      )}&sensor=true&key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}`
    );
    if (data.data.status !== "OK") {
      message.error("Encountered error with zipcode. Please try again later.");
      return false;
    }
    if (data.data.results.length > 0) {
      let latLng =
        data.data.results[0].geometry.location.lat +
        "," +
        data.data.results[0].geometry.location.lng;
      let timeZoneData = await axios.get(
        `https://maps.googleapis.com/maps/api/timezone/json?location=${latLng}&timestamp=${moment().unix()}&key=${
          process.env.REACT_APP_GOOGLE_MAP_API_KEY
        }`
      );

      let addressComponents = data.data.results[0].address_components;
      let addrObj = {};
      addrObj["timezone_id" + id] = timeZoneData.data.timeZoneId;
      addrObj["timezone_name" + id] = timeZoneData.data.timeZoneName;
      addressComponents.forEach(({ types, long_name }) => {
        if (types.includes("locality")) {
          addrObj["city" + id] = long_name;
        }
        if (
          types.includes("administrative_area_level_2") &&
          !addrObj["city" + id]
        ) {
          addrObj["city" + id] = long_name;
        } else if (types.includes("administrative_area_level_1")) {
          addrObj["state" + id] = long_name;
        } else if (types.includes("country")) {
          addrObj["country" + id] = long_name;
        }
      });
      form.setFieldsValue(addrObj);
    }
  };

  return (
    <div className="card">
      <div className="locationNumber">{id + 1}</div>
      <Row gutter={16}>
        <Col xs={24} sm={12} md={8} xl={6}>
          <Tooltip
            trigger={["focus"]}
            title="Location Name"
            placement="topLeft"
          >
            <Form.Item
              name={`name${id}`}
              rules={[
                {
                  required: true,
                  message: "Location Name is required",
                  whitespace: true,
                },
              ]}
            >
              <Input placeholder="Location Name" />
            </Form.Item>
          </Tooltip>
        </Col>
        <Col xs={24} sm={12} md={8} xl={7}>
          <Tooltip
            trigger={["focus"]}
            title="Street Address"
            placement="topLeft"
          >
            <Form.Item
              name={`address${id}`}
              rules={[
                {
                  required: true,
                  message: "Street Address is required",
                  whitespace: true,
                },
              ]}
            >
              <Input placeholder="727 Armbrester Drive" />
            </Form.Item>
          </Tooltip>
        </Col>
        <Col xs={24} sm={12} md={8} xl={4}>
          <Tooltip trigger={["focus"]} title="Zip Code" placement="topLeft">
            <Form.Item
              name={`zipcode${id}`}
              rules={[
                {
                  required: true,
                  message: "Zip Code is required",
                  whitespace: true,
                },
              ]}
            >
              <Input
                onBlur={(e) => handleZipcodeChange(e, id)}
                placeholder="90210"
              />
            </Form.Item>
          </Tooltip>
        </Col>
        <Col xs={24} sm={12} md={8} xl={7}>
          <Form.Item
            name={`city${id}`}
            rules={[
              {
                required: true,
                message: "City is required",
                whitespace: true,
              },
            ]}
          >
            <Input readOnly placeholder="Beverly Hills" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} xl={4}>
          <Form.Item
            name={`state${id}`}
            rules={[
              {
                required: true,
                message: "State is required",
                whitespace: true,
              },
            ]}
          >
            <Input readOnly placeholder="California" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} xl={6}>
          <Form.Item
            name={`country${id}`}
            rules={[
              {
                required: true,
                message: "Country is required",
                whitespace: true,
              },
            ]}
          >
            <Input readOnly placeholder="United States" />
          </Form.Item>
        </Col>
        <Col xs={24} md={16} xl={10}>
          <Row gutter={8} align="start">
            <Col xs={24} md={7}>
              <Popover content={<div className="popoverBusinessHours">Based on the business hours entered here, the shifts hours and tasks are managed. So, please enter accordingly. System do not manage anything outside the shift hours. For e.g if your employee is working outside the business hours, please extend the timing accordingly.</div>}>
                <label className="mt-md-2 mb-md-0 mb-2">Business Hours</label>
              </Popover>
            </Col>
            <Col xs={10} sm={11} md={7}>
              <Tooltip
                trigger={["focus"]}
                title="Start Time"
                placement="topLeft"
              >
                <Form.Item
                  name={`start_time${id}`}
                  rules={[
                    {
                      required: true,
                      message: "Start time is required",
                    },
                  ]}
                >
                  <TimePicker
                    use12Hours
                    allowClear={false}
                    minuteStep={5}
                    showSecond={false}
                    format="h:mm a"
                    suffixIcon={null}
                    placeholder="00:00 AM"
                    className="w-100"
                  />
                </Form.Item>
              </Tooltip>
            </Col>
            <Col xs={4} sm={2} md={3} className="text-center pt-2">
              To
            </Col>
            <Col xs={10} sm={11} md={7}>
              <Tooltip trigger={["focus"]} title="End Time" placement="topLeft">
                <Form.Item
                  name={`end_time${id}`}
                  rules={[
                    {
                      required: true,
                      message: "End time is required",
                    },
                  ]}
                >
                  <TimePicker
                    use12Hours
                    allowClear={false}
                    minuteStep={15}
                    showSecond={false}
                    format="h:mm a"
                    suffixIcon={null}
                    placeholder="00:00 AM"
                    className="w-100"
                  />
                </Form.Item>
              </Tooltip>
            </Col>
          </Row>
        </Col>
        <Col xs={24} sm={12} md={8} xl={4}>
          <Tooltip
            trigger={["focus"]}
            title="No. of Employee"
            placement="topLeft"
          >
            <Form.Item
              name={`total_employee${id}`}
              rules={[
                {
                  required: true,
                  message: "Number of employees is required!",
                },
              ]}
            >
              <InputNumber min={1} max={50} placeholder="Employee count" />
            </Form.Item>
          </Tooltip>
        </Col>
      </Row>
      <Form.Item className="d-none" name={`timezone_id${id}`}></Form.Item>
      <Form.Item className="d-none" name={`timezone_name${id}`}></Form.Item>
      <Form.Item className="d-none" name={`location_id${id}`}></Form.Item>
    </div>
  );
};
